import { BrushIcon } from './BrushIcon';

/**
 * author: Google
 * id B5C72984-BCCF-4729-A7D3-2A07D5794014
 * name brush
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/brush.svg
 * tags
 * - Drawing / Art 
 */
export const PaintbrushIcon = BrushIcon;
export default PaintbrushIcon